import type { FinancialPayer } from './types';

export function payerPrimaryName(payer: FinancialPayer): string {
  const username = payer.username?.trim().replace(/^@+/, '');
  return username ? `@${username}` : payer.displayName;
}

export function payerSecondaryName(payer: FinancialPayer): string {
  const primary = payerPrimaryName(payer);
  const candidates = [payer.displayName, payer.frawId ? `@${payer.frawId.replace(/^@+/, '')}` : null, payer.email];
  const unique = [...new Set(candidates.filter((value): value is string => Boolean(value?.trim()) && value !== primary))];
  return unique.join(' · ') || payer.userId;
}
